<template>
  <div v-if="response.message" class="response" :class="response.type">

    <span class="success" v-if="response.type === 'success'"><font-awesome-icon :icon="['fas', 'check']" /></span>
    <span class="warning" v-if="response.type === 'warning'"><font-awesome-icon :icon="['fas', 'question-circle']" /></span>
    <span class="error" v-if="response.type === 'error'"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>

    <span v-if="type && ['person', 'session_person', 'presentation_person'].includes(type) && response.type === 'warning'">
      {{ _.found_potentially_existing_persons }}
      <ul>
        <li v-for="(pval, pkey) in response.message" :key="pkey">
          <router-link :to="'/person/' + pval.id + '/edit'">
            <span>ID: {{ pval.id }}, {{ pval.first_name }} {{ pval.last_name }}</span>
            <span v-if="pval.city">, {{ pval.city }}</span>
            <span v-if="pval.country">, {{ pval.country.iso_3166_alpha2 }}</span>
            <span v-if="pval.email">, {{ pval.email }}</span>
            <span v-if="pval.alt_email">, {{ pval.alt_email }}</span>
          </router-link>
        </li>
      </ul>
      <button
        v-if="authorized.persons.create"
        @click="createAnyway()">
        <span><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>
        {{ (type === 'person' && $route.params.id) ? _.save_anyway : _.create_anyway }}
      </button>
    </span>
    <span v-else-if="!response.errors.check">{{ _[response.message] || response.message }}</span>
    <span v-else>{{ response.errors.check.join(',') }}</span>

    <router-link v-if="type && type === 'session' && response.message === 'session_successfully_created' && response.type === 'success'" to="/session/create" class="button">
      {{ _.create_another_session }}
    </router-link>

    <router-link v-if="type && type === 'presentation' && response.message === 'presentation_successfully_created' && response.type === 'success'" to="/presentation/create" class="button">
      {{ _.create_another_presentation }}
    </router-link>

    <router-link v-if="type && type === 'person' && response.message === 'person_successfully_created' && response.type === 'success'" to="/person/create" class="button">
      {{ _.create_another_person }}
    </router-link>

    <span class="close" @click="clearResponse()"><font-awesome-icon :icon="['fas', 'times']" /></span>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
export default {
  props: {
    type: null,
  },
  methods: {
    ...mapMutations(['clearResponse']),
    ...mapActions('person_edit', ['createPersonAnyway']),
    ...mapActions('session_persons', ['createSessionPersonAnyway']),
    ...mapActions('presentation_persons', ['createPresentationPersonAnyway']),
    createAnyway() {
      if (this.type === 'person') this.createPersonAnyway();
      if (this.type === 'session_person') this.createSessionPersonAnyway();
      if (this.type === 'presentation_person') this.createPresentationPersonAnyway();
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/response';
.response > .button {
  color: inherit;
  text-decoration: none;
  background: rgba(0,0,0,.15);
  margin-left: 12px;
  padding: 4px 5px;
  border-radius: 4px;
  &:hover {
    background: rgba(0,0,0,.35);
  }
}
</style>
